export function logger(title, value = null) {
  console.debug(title, value ? JSON.stringify(value) : '');
}
